// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-generated-pages-applications-js": () => import("./../../../src/generatedPages/applications.js" /* webpackChunkName: "component---src-generated-pages-applications-js" */),
  "component---src-pages-account-js": () => import("./../../../src/pages/account.js" /* webpackChunkName: "component---src-pages-account-js" */),
  "component---src-pages-analytics-js": () => import("./../../../src/pages/analytics.js" /* webpackChunkName: "component---src-pages-analytics-js" */),
  "component---src-pages-codes-js": () => import("./../../../src/pages/codes.js" /* webpackChunkName: "component---src-pages-codes-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-lab-js": () => import("./../../../src/pages/lab.js" /* webpackChunkName: "component---src-pages-lab-js" */),
  "component---src-pages-performance-js": () => import("./../../../src/pages/performance.js" /* webpackChunkName: "component---src-pages-performance-js" */)
}

